import {Component, Input, OnInit} from '@angular/core';
import {Container, Filter, VoceContainer} from "../_Models";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ServerPaginationService} from "../../shared/_services/server-pagination.service";
import {Permission} from "../../Login/_guards/Permission";
import {ApiRestService} from "../api-rest.service";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-container-voci-list',
  templateUrl: './container-voci-list.component.html'
})
export class ContainerVociListComponent implements OnInit {
  List: VoceContainer[] = [];
  collectionSize: number = 0;
  @Input() hasFiltri: boolean = true;
  @Input() isEditEnabled: boolean = true;
  @Input() Filtri: Filter = {page: 1, size: 10000};
  Container: Container[] = [];
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'targa'
  };
  constructor(
    private modalService: NgbModal,
    private paginationService: ServerPaginationService,
    public permission: Permission,
    private apirestservice: ApiRestService,
    private toastService: ToastrService
  ) { }

  ngOnInit(): void {
    this.refreshTable(1);
  }
  refreshTable(page?: number) {
    this.apirestservice.PrimaNotaContainerList({page: 0, size: 1, stato: "AC", periodo: false}).subscribe(data=>{
      this.Container = data?.data;
    });
    this.apirestservice.PrimaNotaContainerVoci(this.Filtri).subscribe(data=>{
      this.collectionSize = data?.total;
      this.List = data?.data;
    });
  }

  Edit(item: VoceContainer) {
    item.modifica = !item.modifica;
    item.backup = Object.assign({}, item);
    if(item.modifica ) {
      item.containerObjects = item.containerObjects ?? [item.containerObject];
      return;
    }
    if (item.containerObjects?.length > 0 && !isNaN(item.quantita)){
      if(item.quantita > item.disponibilita) {
        this.toastService.warning("La quantità inserita è maggiore della disponibilità (" + item.disponibilita.toString() + ")", "Attenzione!!");
        item.modifica = !item.modifica;
        return;
      }
      item.new_container = item.containerObjects[0].id
      if(item.id)
        this.apirestservice.PrimaNotaContainerVoceUpdate(item).subscribe(() => {
          this.refreshTable();
        })
      return;
    }
    if (item.containerObjects?.length <= 0)
      this.toastService.warning("inserire una data", "Attenzione!!");
    if (isNaN(item.quantita))
      this.toastService.warning("inserire la quantita", "Attenzione!!");


  }
}
